require('./gameActionsController');

"use strict";

angular.module('app.schedule.gameActions.gameActionsDirective', [
    'app.schedule.gameActions.gameActionsController'
])
    .directive('gameActions', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/schedule/gameActions/gameActionsView.html',
                controller: 'app.schedule.gameActions.gameActionsController',
                link: function (scope, elm) {
                    elm.addClass('game-actions');
                }
            };
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/schedule/gameActions/gameActionsDirective.js